module.exports = __webpack_public_path__ + "img/input-pipe.09805d74.svg";